export const SECTION_LABELS = {
  assigned_carrier: 'Assigned carrier (LERG)',
  live_carrier: 'Live carrier lookup',
  carrier_consensus: 'Carrier consensus',
  voip_analysis: 'VoIP analysis',
  geo_info: 'Geographic information',
  formatting: 'Number formatting',
  number_type: 'Number type',
  risk_analysis: 'Risk analysis',
  number_variants: 'Number variants',
  dns: 'DNS records',
  whois: 'WHOIS',
  geo: 'Geolocation',
  reputation: 'Reputation',
  ports: 'Open ports',
};

const TYPE_ORDER = {
  phone: [
    'carrier_consensus',
    'assigned_carrier',
    'live_carrier',
    'voip_analysis',
    'geo_info',
    'formatting',
    'number_type',
    'risk_analysis',
    'number_variants',
  ],
};

export function sectionLabel(key) {
  return SECTION_LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function sortEnrichmentEntries(entries, detectedType) {
  const order = TYPE_ORDER[detectedType] || [];
  const rank = new Map(order.map((key, index) => [key, index]));
  return [...entries].sort((a, b) => {
    const left = rank.has(a[0]) ? rank.get(a[0]) : 999;
    const right = rank.has(b[0]) ? rank.get(b[0]) : 999;
    if (left !== right) return left - right;
    return a[0].localeCompare(b[0]);
  });
}

export function statusClass(status) {
  if (status === 'success') return 'enrichment-status-success';
  if (status === 'skipped') return 'enrichment-status-skipped';
  if (status === 'error') return 'enrichment-status-error';
  return 'enrichment-status-unknown';
}
